import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { MeSelectors } from '../redux/selectors';

const useNavigateToDefaultRoute = () => {
  const navigate = useNavigate();
  const me = useSelector(MeSelectors.selectMe);

  const navigateToDefaultRoute = () => {
    const defaultRoute = me.allowedPageRoutes.find((route) => route.isDefault || route.isFallback);
    if (defaultRoute) navigate(defaultRoute.path);
  };
  return navigateToDefaultRoute;
};

export default useNavigateToDefaultRoute;
